import React from 'react';
import Cookies from 'js-cookie';
import { Redirect } from 'react-router-dom';

const Invite = ({ match: { params } }) => {
  Cookies.set('refCode', params.refCode, { expires: 14 });
  return (
    <Redirect to={{ pathname: '/signup', refCode: params.refCode }} />
  );
};

export default Invite;



// WEBPACK FOOTER //
// ./src/components/Referral/Invite.js